import { z } from 'zod'

export interface Filter<T = unknown> {
  parse(urlValue: string): T | null
  serialize(value: T): string
  getSchema(): z.ZodSchema<T>
}

export abstract class BaseFilter<T = unknown> implements Filter<T> {
  abstract parse(urlValue: string): T | null
  abstract serialize(value: T): string
  abstract getSchema(): z.ZodSchema<T>

  protected safeParse(value: unknown): T | null {
    const schema = this.getSchema()
    const result = schema.safeParse(value)
    return result.success ? result.data : null
  }
}
